import React, { useState, useEffect, useRef } from 'react';
import { FaWhatsapp, FaPhoneAlt, FaTimes } from 'react-icons/fa';

const FloatingContact = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [show, setShow] = useState(true);
  const lastScrollY = useRef(0); // useRef to persist value across renders

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > lastScrollY.current && window.scrollY > 100) {
        setShow(false);
      } else {
        setShow(true);
      }
      lastScrollY.current = window.scrollY;
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []); // Empty dependency array – safe because ref persists

  const toggleMenu = () => setIsOpen(!isOpen);

  const whatsappNumber = '265988252674';
  const callNumber = '+265892086091';

  return (
    <div className={`fixed bottom-6 right-6 z-50 transition-all duration-300 ${show ? 'opacity-100' : 'opacity-0 pointer-events-none'}`}>
      <button
        onClick={toggleMenu}
        className="bg-gold-500 hover:bg-gold-600 text-white rounded-full w-14 h-14 flex items-center justify-center shadow-lg transition-all duration-300 focus:outline-none"
        aria-label="Contact options"
      >
        {isOpen ? <FaTimes size={24} /> : <FaWhatsapp size={28} />}
      </button>

      {isOpen && (
        <div className="absolute bottom-16 right-0 flex flex-col space-y-3">
          <a
            href={`https://wa.me/${whatsappNumber}`}
            target="_blank"
            rel="noopener noreferrer"
            className="bg-green-500 hover:bg-green-600 text-white rounded-full w-12 h-12 flex items-center justify-center shadow-lg transition-all duration-300"
            aria-label="Chat on WhatsApp"
          >
            <FaWhatsapp size={24} />
          </a>
          <a
            href={`tel:${callNumber}`}
            className="bg-blue-500 hover:bg-blue-600 text-white rounded-full w-12 h-12 flex items-center justify-center shadow-lg transition-all duration-300"
            aria-label="Call us"
          >
            <FaPhoneAlt size={22} />
          </a>
        </div>
      )}
    </div>
  );
};

export default FloatingContact;